import type { StageConfig } from '@capture/shared';
import { StageDeepLinks } from './StageDeepLinks';

export function ImportPanel({ config: _config, onChange: _onChange }: { config: StageConfig; onChange: (c: StageConfig) => void }) {
  return (
    <div className="stage-panel">
      <p>Import runs automatically when files arrive.</p>
      <StageDeepLinks stage="import" />
    </div>
  );
}
